module.exports = __webpack_public_path__ + "img/Syrenis-white.ff9addb8.svg";